import React from "react";
import { RichText } from "@components/cms/rich-text-renderer/RichText";
import type { Document } from "@contentful/rich-text-types";
import { Box } from "@ui/components/layout/box/Box";
import { messageItemStyle, getSeparatorStyle } from "./USPMessagesList.styles";

interface USPMessagesListProps {
    messages: Document[];
    showSeparator?: boolean;
    keyPrefix?: string;
    isSaleSeason?: boolean;
}

export const USPMessagesList: React.FC<USPMessagesListProps> = ({
    messages,
    showSeparator = true,
    keyPrefix = "",
    isSaleSeason = false,
}) => {
    const separatorStyle = getSeparatorStyle(isSaleSeason);

    return (
        <>
            {messages.map((item, i) => (
                <Box key={`${keyPrefix}${i}`} sx={messageItemStyle}>
                    <RichText data={item} />
                    {showSeparator && i < messages.length - 1 && (
                        <Box as="span" sx={separatorStyle}>
                            •
                        </Box>
                    )}
                </Box>
            ))}
        </>
    );
};

export default USPMessagesList;
